import {
  Table,
  TableCell,
  TableRow,
  WidthType,
  convertInchesToTwip,
  TableLayoutType,
} from "docx";
import { paragraphCentered, paragraphLeft } from "../results/paragraphs";

export const tableSummary = (valueObj) => {
  console.log({ valueObj });
  const arr = Object.values(valueObj).sort((a, b) =>
    a.points < b.points ? 1 : -1
  );
  return new Table({
    layout: TableLayoutType.FIXED,
    columnWidths: [
      1000, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500,
      500, 500, 500,
    ],
    width: {
      size: 100,
      type: WidthType.PERCENTAGE,
    },
    rows: [
      new TableRow({
        margins: {
          top: convertInchesToTwip(0.05),
          bottom: convertInchesToTwip(0.05),
          left: convertInchesToTwip(0.05),
          right: convertInchesToTwip(0.05),
        },
        children: [
          new TableCell({
            margins: {
              top: convertInchesToTwip(0.05),
              bottom: convertInchesToTwip(0.05),
              left: convertInchesToTwip(0.05),
              right: convertInchesToTwip(0.05),
            },
            width: { size: 300, type: WidthType.AUTO },
            children: [paragraphLeft("Note")],
          }),
          ...arr.map(
            (i) => new TableCell({ children: [paragraphCentered(i.note)] })
          ),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            margins: {
              top: convertInchesToTwip(0.05),
              bottom: convertInchesToTwip(0.05),
              left: convertInchesToTwip(0.05),
              right: convertInchesToTwip(0.05),
            },
            width: { size: 300, type: WidthType.AUTO },
            children: [paragraphLeft("Punkte")],
          }),
          ...arr.map(
            (i) =>
              new TableCell({
                children: [paragraphCentered(`${i.points}`)],
              })
          ),
        ],
      }),

      new TableRow({
        children: [
          new TableCell({
            margins: {
              top: convertInchesToTwip(0.05),
              bottom: convertInchesToTwip(0.05),
              left: convertInchesToTwip(0.05),
              right: convertInchesToTwip(0.05),
            },
            width: { size: 300, type: WidthType.AUTO },
            children: [paragraphLeft("Anzahl")],
          }),
          ...arr.map(
            (i) =>
              new TableCell({
                children: [paragraphCentered(`${i.count}`)],
              })
          ),
        ],
      }),
    ],
  });
};
